"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(inlineType) {
  return {
    serialize: function serialize(obj, children) {
      if (obj.type === inlineType) {
        return _react.default.createElement("p", null, children);
      }
    }
  };
}